export default "__VITE_ASSET__DmHCAAT7__"